import { Outlet } from 'react-router-dom'

import { ContractsSettingPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/contracts_settings/lib/CollectionsBootstrap'

const RootPage = () => {
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(ContractsSettingPageDocument, {
    variables: {
      companyId: company.id,
    },
  })

  return (
    <CollectionsBootstrap>
      <Outlet
        context={{
          loading,
          error: !!error,
          data,
        }}
      />
    </CollectionsBootstrap>
  )
}

export default RootPage
